"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ramda = require("ramda");

var _mergePartWithQuery = _interopRequireDefault(require("./mergePartWithQuery"));

var mergeQuery = function mergeQuery(query, filterParts) {
  return (0, _ramda.isEmpty)(filterParts) ? query : (0, _mergePartWithQuery.default)(query, filterParts);
};

var _default = mergeQuery;
exports.default = _default;